module.exports = __webpack_public_path__ + "static/media/santa-isabel-login.88ecb4c2.svg";